<template>
  <div class="row">
    <div class="col-12 col-lg-8 c g">
    <div class="card card-body" v-if="!loading">
        اختر ملف الشهادات (PDF)
        <br><br>
        <input
            id="ingredient_file"
            type="file" accept=".pdf" @change="listenFile()"
        />
    </div>
    <div class="card card-body text-center" v-if="loading">
            <img :src="require('@/assets/images/results-ai.gif')" width="150" class="c" alt="">
            <h5><img :src="require('@/assets/images/loading.svg')" width="25" class="c" alt=""> جاري التحليل...</h5>
            <h5 class="text-primary">
                &nbsp; <span class="statusC" v-html="status"></span>
            </h5>
            <div class="col-12 text-center" style="position: relative; top: 5px">
                <div class="progress" v-if="loading" style="height: 20px; max-width: 300px; margin: 0px auto; border-radius: 5px !important">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="`width: ${percent}%; border-radius: 5px !important`" :aria-valuenow="percent" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
            </div>
            <br>
            <div class="col-12">
                <button class="btn btn-primary" @click="loading = false;">
                    <i class="fa fa-plus"></i>
                    تحليل شهادة اخرى
                </button>
            </div>
        </div>
    </div>
    <div class="col-12" v-if="first && history.length">
        <div class="card card-body">
            <h5>
                <i class="fa fa-clock-o"></i>
                سجل العمليات
            </h5>
            <div class="col-12 table-responsive">
                <table class="table table-hover table-bordered table-sm">
                    <thead>
                        <th>
                            التاريخ
                        </th>
                        <th>
                            ملف الشهادة
                        </th>
                        <th>
                            الحالة
                        </th>
                        <th>
                            خيارات
                        </th>
                    </thead>
                    <tbody>
                        <tr v-for="r in history" :key="r._id">
                            <td>
                                {{ r.date }}
                            </td>
                            <td>
                                <a :href="api + r.file.replace('./', '/')" target="_blank"><i class="fa fa-external-link"></i> عرض</a>
                            </td>
                            <td>
                                <span @click="$router.push('/_results/fast-single/' + r.process_id)" class="btn btn-sm btn-success" v-if="r.status == 1">
                                    <i class="fa fa-check"></i> عرض النتيجة
                                </span>
                                <span v-if="r.status != 1">
                                    <img :src="require('@/assets/images/loading.svg')" width="16" class="c" alt="">
                                    {{ r.text }}
                                </span>
                            </td>
                            <td>
                                <button class="btn btn-sm btn-outline-danger" @click="deleter(r._id)" v-if="r.status == 1">
                                    <i class="fa fa-trash"></i> حذف
                                </button>
                                <button class="btn btn-sm btn-outline-danger" @click="deleter(r._id)" v-if="r.status == 0">
                                    <i class="fa fa-times"></i> الغاء العملية
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import CanvasJS from '@canvasjs/charts';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import { BFormCheckbox, VBModal, BModal, } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
export default {
    components: {
        AppCollapse,
        AppCollapseItem,
        BModal
    },
    directives: {
        Ripple,
        "b-modal": VBModal,
    },
    data(){
        return {
            api: api,
            result: {},
            viewstudents: [],
            viewstubjects: [],
            history: [],
            user: JSON.parse(localStorage.getItem('user')),
            file: null,
            loading: false,
            first: true,
            status: "",
            percent: "",
            process_id: 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
                return v.toString(16);
            })
        }
    },
    created(){
        if(!checkPer("results")){
            this.$router.push('/NotPermitted')
            return false;
        }
        var g = this;
        g.getHistory()
    },
    methods: {
        getHistory(){
            var g = this;
            $.post(api + '/user/results/fast-history', {
                jwt: this.user.jwt,
            }).then(function(r){
                g.history = r.response
                var dd = false;
                g.history.forEach(function(a){
                    if(a.status != 1){
                        dd = true;
                    }
                })
                if(dd){
                    setTimeout(function(){
                        g.getHistory()
                    }, 5000)
                }
            })
        },
        listenFile() {
            var g = this;
            g.process_id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
                return v.toString(16);
            });
            g.loading = true;
            var Upload = function (file) {
                this.file = file;
            };
            Upload.prototype.getType = function () {
                return this.file.type;
            };
            Upload.prototype.getSize = function () {
                return this.file.size;
            };
            Upload.prototype.getName = function () {
                return this.file.name;
            };
            Upload.prototype.doUpload = function () {
                var that = this;
                var formData = new FormData();

                // add assoc key values, this will be posts values
                formData.append("file", this.file, this.getName());
                formData.append("jwt", g.user.jwt);

                $.ajax({
                type: "POST",
                url: api + '/user/general/upload-tmp-files',
                xhr: function () {
                    var myXhr = $.ajaxSettings.xhr();
                    if (myXhr.upload) {
                    myXhr.upload.addEventListener(
                        "progress",
                        that.progressHandling,
                        false
                    );
                    }
                    return myXhr;
                },
                success: function (data) {
                    // your callback here
                    $("#progress-wrp").fadeOut("slow");
                    if(data.status != 100){
                       return alert(data.response, 200)
                    }
                    g.file = data.response
                    g.step = 4;
                    g.process()
                },
                error: function (error) {
                    // handle error
                    alert("حدث خطأ");
                },
                async: true,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                timeout: 60000,
                });
            };

            Upload.prototype.progressHandling = function (event) {
                var percent = 0;
                var position = event.loaded || event.position;
                var total = event.total;
                var progress_bar_id = "#progress-wrp";
                if (event.lengthComputable) {
                percent = Math.ceil((position / total) * 100);
                }
                // update progressbars classes so it fits your code
                $(progress_bar_id + " .progress-bar").css("width", +percent + "%");
                $(progress_bar_id + " .status").text(percent + "%");
            };
            $("#progress-wrp").fadeIn("slow");
            var file = $("#ingredient_file")[0].files[0];
            var upload = new Upload(file);

            // maby check size or type here with upload.getSize() and upload.getType()

            // execute upload
            upload.doUpload();
        },
        deleter(id){
            var g = this;
            if(confirm("متأكد من الحذف؟")){
                $.post(api + '/user/results/fast-delete', {
                    jwt: this.user.jwt,
                    id: id
                }).then(function(r){
                    if(r.status == 200){
                        alert(r.response, 200)
                    }
                    g.getHistory()
                })
            }
        },
        process(){
            var g = this;
            $.ajax({
                url: api + '/user/results/fast-process-status',
                method: 'POST',
                data: {  jwt: this.user.jwt, process_id: g.process_id }, // Your POST data
                xhrFields: {
                    // Important for streaming
                    onprogress: function(e) {
                        // This function will be called as data arrives
                        var chunk = e.currentTarget.responseText;
                        // Process the chunk of data received
                        try{
                            if(chunk.split("\n")[chunk.split("\n").length - 1]?.includes("{")){
                                g.status = JSON.parse(chunk.split("\n")[chunk.split("\n").length - 1]).response;
                                g.percent = JSON.parse(chunk.split("\n")[chunk.split("\n").length - 1]).percent;
                            }
                        }catch(e){}
                    }
                },
                success: function(data) {
                },
                error: function(xhr, status, error) {
                    console.error('Error:', error);
                }
            });
            setTimeout(() => {
                g.getHistory()
            }, 1000);
            $.post(api + '/user/results/fast', {
                jwt: this.user.jwt,
                file: g.file.split("/tmp/")[1],
                process_id: g.process_id
            })
            .then(function(r){
                g.loading = false;
                if(r.status == 100){
                    setTimeout(() => {
                        g.$router.push('/_results/fast-single/' + r.response)
                    }, 1000);
                }else{
                    alert(r.response, 200)
                }
            })
            .fail(function(){
                g.loading = false;
                alert("حدث خطأ في الاتصال", 200)
            })
        }
    }
}
</script>

<style>
#progress-wrp {
  border: 1px solid #0099cc;
  padding: 1px;
  position: relative;
  height: 30px;
  border-radius: 3px;
  margin: 10px;
  text-align: left;
  background: #fff;
  box-shadow: inset 1px 3px 6px rgba(0, 0, 0, 0.12);
  display: none;
}

#progress-wrp .progress-bar {
  height: 100%;
  border-radius: 3px;
  background-color: greenyellow;
  width: 0;
  box-shadow: inset 1px 1px 10px rgba(0, 0, 0, 0.11);
}

#progress-wrp .status {
  top: 3px;
  left: 50%;
  position: absolute;
  display: inline-block;
  color: #000000;
}
.table-responsive{
   min-height: 0px !important;
}
</style>